"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertToMountainTime = convertToMountainTime;
exports.formatDate = formatDate;
var MOUNTAIN_UTC_OFFSET = 7;
var ONE_HOUR_IN_MILLISECONDS = 1000 * 60 * 60;

function addZero(num) {
  return "0".concat(num);
}

function convertToMountainTime(date) {
  var currentTimestamp = date.getTime();
  var currentOffset = date.getTimezoneOffset() / 60;
  var offsetDiff = MOUNTAIN_UTC_OFFSET - currentOffset;
  var absoluteOffsetDiff = Math.abs(offsetDiff);
  var offsetInMilliseconds = ONE_HOUR_IN_MILLISECONDS * absoluteOffsetDiff;

  if (offsetDiff > 0) {
    return new Date(currentTimestamp - offsetInMilliseconds);
  } else {
    return new Date(currentTimestamp + offsetInMilliseconds);
  }
}

function formatDate(date) {
  var year = date.getFullYear();
  var day = date.getDate();
  var milliseconds = date.getMilliseconds();
  var month = date.getMonth() + 1;

  if (month < 10) {
    month = addZero(month);
  }

  ;
  var seconds = date.getSeconds();

  if (seconds < 10) {
    seconds = addZero(seconds);
  }

  var minutes = date.getMinutes();

  if (minutes < 10) {
    minutes = addZero(minutes);
  }

  var hour = date.getHours();

  if (hour < 10) {
    hour = addZero(hour);
  }

  return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(minutes, ":").concat(seconds, ".").concat(milliseconds);
}